import { render } from "./ProductosCluster.vue?vue&type=template&id=9e91aff0"
import script from "./ProductosCluster.vue?vue&type=script&lang=js"
export * from "./ProductosCluster.vue?vue&type=script&lang=js"

import "./ProductosCluster.vue?vue&type=style&index=0&id=9e91aff0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__